// 保留两位小数
export function returnFloat(num) {
  // 转成字符串类型  如能确定类型 这步可省去
  num = num.toString()
  if (num.indexOf('.') !== -1) {
    let [integerPart, decimalPart] = num.split('.')
    if (decimalPart.length > 2) {
      decimalPart = decimalPart.substring(0, 2)
    } else if (decimalPart.length === 1) {
      decimalPart += '0'
    }
    num = `${integerPart}.${decimalPart}`
  } else {
    num += '.00'
  }
  return num
}

// 数字则转成K表达
export function numberTransformK(num, locaCode) {
  if (typeof num !== 'number' && typeof num !== 'string') {
    return ''
  }
  const myNum = Number(num)
  if (!Number.isFinite(myNum)) {
    return ''
  }
  if (num == 0) {
    return '0'
  }
  // 印尼
  if (locaCode === 'ID') {
    const kValue = Math.floor((myNum / 1000) * 100) / 100
    // 如果是整数则直接返回
    if (Number.isInteger(kValue)) {
      return `${kValue}K`
    }
    // 非整数
    else {
      // 否则取后两位小数
      return `${kValue.toFixed(2)}K`
    }
  }
  // 非印尼
  else {
    return returnFloat(num)
  }
}

export function decryptCode(str, privateKey) {
  const encrypt = new JSEncrypt()
  encrypt.setPrivateKey(privateKey)
  const data = encrypt.decrypt(str)
  return data
}

export function encryptCode(str, publicKey) {
  const encrypt = new JSEncrypt()
  encrypt.setPublicKey(publicKey)
  const data = encrypt.encrypt(str)
  return data
}

export function getQueryParam(url, paramName) {
  const regex = new RegExp('[?&]' + paramName + '=([^&]*)')
  const match = url.match(regex)
  return match ? decodeURIComponent(match[1]) : null
}

// 随机字符串
export function generateRandomString(length = 8) {
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length))
  }

  return result
}

// 获取URL中的所有查询参数并返回对象
export function getQueryParams(url) {
  if (!url) return {}

  // 创建一个用于存储参数的对象
  const params = {}

  // 获取问号后面的部分
  const queryString = url.indexOf('?') !== -1 ? url.split('?')[1] : ''

  // 如果没有查询字符串，返回空对象
  if (!queryString) return params

  // 分割查询字符串为键值对数组
  const pairs = queryString.split('&')

  // 遍历每个键值对
  for (let i = 0; i < pairs.length; i++) {
    const pair = pairs[i].split('=')
    const key = decodeURIComponent(pair[0])
    const value = decodeURIComponent(pair[1] || '')
    params[key] = value
  }

  return params
}

// 在文件开头添加 deviceId 生成函数
export function createDeviceId() {
  return 'device_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now()
}

// 对比版本号
export function compareVersion(v1, v2) {
  try {
    const parts1 = v1.split('.').map(Number)
    const parts2 = v2.split('.').map(Number)
    const len = Math.max(parts1.length, parts2.length)

    for (let i = 0; i < len; i++) {
      const num1 = parts1[i] || 0
      const num2 = parts2[i] || 0

      if (num1 > num2) return 1 // v1 更大
      if (num1 < num2) return -1 // v1 更小
    }

    return 0 // 相等
  } catch (error) {
    // 异常
    return -2
  }
}

// 时间处理 传入秒
export function getDateDiff(seconds) {
  if (seconds) {
    // 计算天数
    var days = Math.floor(seconds / (24 * 3600))
    // 剩余秒数
    seconds %= 24 * 3600
    // 计算小时
    var hours = Math.floor(seconds / 3600)
    // 剩余秒数
    seconds %= 3600
    // 计算分钟
    var minutes = Math.floor(seconds / 60)
    // 剩余秒数
    seconds %= 60
    if (days != 0) {
      return days + 'day ' + hours + 'h ' + minutes + 'min ' + seconds + 's'
    }
    if (hours != 0) {
      return hours + 'h' + minutes + 'min ' + seconds + 's'
    }
    if (minutes != 0) {
      return minutes + 'min ' + seconds + 's'
    }
    if (seconds != 0) {
      return seconds + 's'
    }
  }
  // seconds为假，则返回0
  else {
    return 0
  }
}

/**
 * 为列表每一项附加 localKey，供 v-for :key 使用。
 */
export function attachLocalKey(list) {
  if (!Array.isArray(list)) return []
  return list.map((item) => ({
    ...item,
    localKey: Date.now(),
  }))
}
